import { AUTH_STATE_KEY } from 'modules/auth';

export const getToken = () => {
  return JSON.parse(localStorage.getItem(AUTH_STATE_KEY) ?? '{}')?.authData?.access_token;
};

export const setAuthState = (authState: any) => {
  localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(authState));
};
